export default {
    baseUrl: process.env.VUE_APP_BASE_URL,
    wsUrl: process.env.VUE_APP_WS_URL,
    apiUrl: process.env.VUE_APP_API_URL
};
